import { createContext, Fragment, useState } from 'react'

import ReactSlidingPane from 'react-sliding-pane'

import { useCurrentUserId } from 'lib/use-current-user-id'
import { useUserSubscription } from 'lib/use-user-subscription'

import SlideContainer from './SlideContainer'

interface ContextProps {
  elementId?: string
  setElementId: Function
  subscriptionPlanCode: string
  userSubscriptionLoading: boolean
}

export const Context = createContext<ContextProps>({
  elementId: undefined,
  setElementId: () => ({}),
  subscriptionPlanCode: 'essential',
  userSubscriptionLoading: false,
})
Context.displayName = 'AuthorizationsContext'

export const Provider = Context.Provider
export const Consumer = Context.Consumer

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const AuthorizationsContext = ({ children }: Props) => {
  const [elementId, _setElementId] = useState<string | undefined>()
  const userId = useCurrentUserId()
  const { subscriptionPlanCode, loading: userSubscriptionLoading } =
    useUserSubscription(userId)

  const setElementId = (value: string | undefined) => {
    _setElementId(value)
  }

  const value = {
    elementId,
    setElementId,
    subscriptionPlanCode,
    userSubscriptionLoading,
  }

  const isOpen = Boolean(elementId)

  return (
    <Provider value={value}>
      {children}
      {isOpen && (
        <ReactSlidingPane
          from="bottom"
          hideHeader
          isOpen={isOpen}
          onRequestClose={() => setElementId(undefined)}
          overlayClassName="z-30 w-screen"
          shouldCloseOnEsc
          width="100%"
        >
          <SlideContainer id={elementId} />
        </ReactSlidingPane>
      )}
    </Provider>
  )
}

export default AuthorizationsContext
